import { Button } from "@mui/material"
import { useParams } from "react-router"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { navigateScheduleCommentary } from "authoring/routes/project/utilities/project-navigation"

export function ReviewCommentaryButton() {
    const { projectId, scheduleId } = useParams()

    return (
        <Secure demand={AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND} fallback={<Frag />}>
            <Button
                onClick={() => navigateScheduleCommentary({ projectId, scheduleId })}
                variant="outlined"
                data-cy="review-commentary-button"
            >
                View Commentary
            </Button>
        </Secure>
    )
}
